import { configureStore } from "@reduxjs/toolkit"
import authReducer from "./AuthSlice"
import Global from "./GlobalSlice"
import cartReducer from "./CartSlice"

export const store = configureStore({
  reducer: {
    auth: authReducer,
    global: Global,
    cart: cartReducer,
  },
})

